export const RoomType = {
  RED: 'RED',
  GRAY: 'GRAY',
  YELLOW: 'YELLOW',
};
